import SFeaturesDesktop from './SFeaturesDesktop'

export default SFeaturesDesktop
